import { NamespacedStoreState } from '@Types/store.types';
import { createSelector } from '@reduxjs/toolkit';
import { moduleNamespace } from '@Store/config.store';
import { useSelector } from 'react-redux';

const parseNamespace = (state: NamespacedStoreState) => state[moduleNamespace];

const riskTemplateCatalogStoreSelector = createSelector(
	parseNamespace,
	state => state.RiskTemplateCatalogStore,
);

export const selectRiskTemplateCatalogStatus = createSelector(
	riskTemplateCatalogStoreSelector,
	state => state.status,
);
export const selectRiskTemplateCatalogTemplates = createSelector(
	riskTemplateCatalogStoreSelector,
	state => state.templates,
);

export const useSelectRiskTemplateCatalog = () =>
	useSelector(riskTemplateCatalogStoreSelector);
